"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var style_1 = require("./style");
var Header = function (_a) {
    var apps = _a.apps, social = _a.social;
    return (react_1.default.createElement(style_1.Wrapper, null,
        react_1.default.createElement("div", { className: 'Header__socialLinks' }, (social !== undefined) ? social.map(function (_a) {
            var Icon = _a.icon, label = _a.label, linkProps = _a.linkProps;
            return (react_1.default.createElement("a", { className: 'Header__link', href: linkProps.href, key: label, target: linkProps.target },
                react_1.default.createElement(Icon, { className: 'Header_icon' }),
                label));
        }) : null),
        react_1.default.createElement("div", { className: 'Header__apps' },
            ((apps === null || apps === void 0 ? void 0 : apps.title) !== undefined) ? (react_1.default.createElement("div", { className: 'Header__appsTitle' }, apps.title)) : null,
            ((apps === null || apps === void 0 ? void 0 : apps.items) !== undefined) ? apps.items.map(function (_a) {
                var Icon = _a.icon, label = _a.label, linkProps = _a.linkProps;
                return (react_1.default.createElement("a", { className: 'Header__link Header__lightColor', href: linkProps.href, key: label, target: linkProps.target },
                    react_1.default.createElement(Icon, { className: 'Header_icon' }),
                    label));
            }) : null)));
};
exports.default = Header;
